<!-- RSK Row -->
@if (hssBuilderService.shouldShowRsk(leg)) {
  <div
    class="flight-row rsk-row"
    [class.opacity-5]="
      enhanced &&
      hssBuilderService.isFaded(leg, 'rsk') &&
      leg.isCancelled.text === 'False'
    "
    [class.e-cxld]="enhanced && leg.isCancelled.text === 'True'"
  >
    <span
      class="status"
      [class.e-skd]="enhanced && leg.isCancelled.text === 'False'"
      >RSK
    </span>
    <!-- Day -->
    <span [class.e-day]="enhanced && leg.isCancelled.text === 'False'">{{
      hssBuilderService.getDay(leg, "RSK").padEnd(3, " ")
    }}</span>
    <!-- Equip -->
    <span
      [class.e-eq]="enhanced && leg.isCancelled.text === 'False'"
      [class]="
        hssBuilderService.getChangedClass(leg.actualEquipCode.didChange, index)
      "
      >{{ hssBuilderService.getSkdEquipCode(leg).padEnd(3, " ") }}</span
    >
    <!-- Flt Num -->
    <span
      [class.e-flt-num]="enhanced && leg.isCancelled.text === 'False'"
      [class]="hssBuilderService.getChangedClass(leg.fltNum.didChange, index)"
      >{{ hssBuilderService.toInt(leg.fltNum.text).padStart(4, " ") }}</span
    >
    <!-- Dep Sta -->
    <span
      [class.e-dep-sta]="enhanced && leg.isCancelled.text === 'False'"
      [class]="
        hssBuilderService.getChangedClass(leg.depStation.didChange, index)
      "
    >
      {{ leg.depStation.text.padEnd(4, " ") }}</span
    >
    <!-- Dep Time -->
    <span
      [class.e-dep-time]="enhanced && leg.isCancelled.text === 'False'"
      [class]="
        hssBuilderService.getChangedClass(
          leg.depTimeReSchedLocal.didChange,
          index
        )
      "
      >{{ leg.depTimeReSchedLocal.text | hssTime }}
    </span>
    <!-- Meal -->
    <span
      [class.e-meal]="enhanced && leg.isCancelled.text === 'False'"
      [class]="hssBuilderService.getChangedClass(leg.meal.didChange, index)"
      >{{ leg.meal.text.padEnd(2, " ") }}</span
    >
    <!-- Arr Sta -->
    <span
      [class.e-arr-sta]="enhanced && leg.isCancelled.text === 'False'"
      [class]="
        hssBuilderService.getChangedClass(leg.arrStation.didChange, index)
      "
      >{{ leg.arrStation.text.padEnd(4, " ") }}</span
    >
    <!-- Arr Time -->
    <span
      [class.e-arr-time]="enhanced && leg.isCancelled.text === 'False'"
      [class]="
        hssBuilderService.getChangedClass(
          leg.arrTimeReSchedLocal.didChange,
          index
        )
      "
      >{{ leg.arrTimeReSchedLocal.text | hssTime }}
    </span>
    <!-- Add Code -->
    <span
      [class.e-ac]="enhanced && leg.isCancelled.text === 'False'"
      [class]="hssBuilderService.getChangedClass(leg.addCode.didChange, index)"
      >{{ leg.addCode.text.padEnd(2, " ") }}</span
    >
    <!-- Flt Time -->
    <span
      [class.e-flt-time]="
        enhanced &&
        leg.isCancelled.text === 'False' &&
        leg.isDhOrSurface.text === 'False' &&
        leg.isCancelled.text === 'False'
      "
      [class.e-dh]="
        enhanced &&
        leg.isCancelled.text === 'False' &&
        leg.isDhOrSurface.text === 'True' &&
        leg.isCancelled.text === 'False'
      "
      [class]="
        hssBuilderService.getChangedClass(
          leg.depTimeReSched.didChange || leg.arrTimeReSched.didChange,
          index
        )
      "
      >{{ hssBuilderService.getFlightTimeReSched(leg).padStart(7, " ") }}</span
    >
    <!-- GTR Time (Doesn't apply to RSK) -->
    <span>{{ " ".padStart(5, " ") }}</span>
    <!-- Gnd Time -->
    <span
      [class.e-gnd-time]="enhanced && leg.isCancelled.text === 'False'"
      [class]="
        hssBuilderService.getChangedClass(
          leg.groundTimeReSched.didChange,
          index
        )
      "
      >{{ (leg.groundTimeReSched.text | hssDuration).padStart(5, " ") }}</span
    >
    <!-- Seat Actual -->
    <span
      [class]="
        hssBuilderService.getChangedClass(leg.seatActual.didChange, index)
      "
      >{{ hssBuilderService.getSeatActual(leg, hss).padStart(8, " ") }}</span
    >
  </div>
}
